import React from 'react';
import Link from 'next/link';
import { Container, Box, Grid, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { Headline, Subheadline, StartButton, PlayDemoButton } from './Components/styles';
import ScrollAnimation from './Components/ScrollAnimation';
import CheckIcon from '@mui/icons-material/Check';
import Image from 'next/image';


export default function HeroSection() {

  return (
    <Container maxWidth="md" sx={{ pt: 15, alignItems: 'center' }}>
      <ScrollAnimation animateIn="fadeInUp" delay={0.3}>

        <Headline variant="h2" component="h1" sx={{
          fontSize: { xs: '2.5rem', md: '3.5rem' }, fontWeight: 700,
          color: 'white', textAlign: 'center', pr: 2
        }}>
          Go Viral on LinkedIn: AI-Powered Content That Gets You Noticed
        </Headline>

        <Subheadline variant="h5" style={{
          color: 'white',
          fontSize: { xs: '1.5rem', md: '1.8rem' },
          padding: '0 5vw',
          textAlign: 'center', fontWeight: 400, lineHeight: '28px', marginBottom: '53px'
        }}>
          Generate, Schedule, and Optimize Engaging LinkedIn Posts with AI. Say Goodbye to Creative Blocks and Hello to Consistent Engagement.
        </Subheadline>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 0, justifyContent: 'center' }}>
          <Link href="/app/login" underline="none" hover="none">
            <motion.div
              whileHover={{ scale: 1.10 }}
              whileTap={{ scale: 0.95 }}
            >
              <StartButton variant="contained" sx={{ p: '20px 5rem' }}>
                <Typography variant="h6" style={{ color: 'white', fontWeight: 700 }}>
                  Get Started
                </Typography>
                <ArrowForwardIcon sx={{ ml: 1 }} />
              </StartButton>
            </motion.div>
          </Link>
        </Box>

        {/* build box with checkicon no credit card required and checkicon with 7 day free trial */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0, mt: 0, justifyContent: 'center', padding: '0 2vw' }}>
          <CheckIcon sx={{ color: '#8BC34A', fontSize: '1.5rem', mr: 1 }} />
          <Typography variant="caption " style={{ color: 'white' }}>
            <strong>No Credit Card</strong> Required
          </Typography>

          <CheckIcon sx={{ color: '#8BC34A', fontSize: '1.5rem', ml: 5, mr: 1 }} />
          <Typography variant="caption " style={{ color: 'white' }}>
            7 Day Free Trial
          </Typography>
        </Box>

      </ScrollAnimation>
    </Container>
  );
}
